import React, { useId, useState } from 'react';
import './MintNftDisplay.css';

export default function MintProgress({ steps, status = '', busy = false, error = '', style }) {
    const [open, setOpen] = useState(false);
    const detailsId = useId();
    const completed = steps.filter(step => step.done).length;
    const current = steps.findIndex(step => !step.done);
    const message = status || (error ? 'Mint paused. Check the error and retry.'
        : completed === steps.length ? 'NFT minted.' : busy ? steps[current]?.label : 'Ready to mint');
    return <div className="mint-progress" style={style}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={event => { if (!event.currentTarget.contains(document.activeElement)) setOpen(false); }}
        onFocus={() => setOpen(true)} onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false); }}
        onKeyDown={event => { if (event.key === 'Escape') { setOpen(false); event.stopPropagation(); } }}>
        <button type="button" className="mint-progress-trigger" onClick={() => setOpen(true)}
            aria-label={`Mint progress: ${completed}/${steps.length}. ${message}`}
            aria-expanded={open} aria-describedby={open ? detailsId : undefined}>
            <span role="status" aria-live="polite">{message}</span>
            <span className="mint-progress-count" aria-label={`${completed} of ${steps.length} stages complete`}>{completed}/{steps.length}</span>
        </button>
        {open && <div id={detailsId} role="tooltip" className="mint-progress-details">
            <div className="mint-progress-card">
                <strong>Mint steps</strong>
                <ol>{steps.map((step, index) => <li key={step.label} aria-current={busy && index === current ? 'step' : undefined}>
                    <span>{step.label}</span><small>{step.done ? 'Complete' : busy && index === current ? 'Current' : 'Pending'}</small>
                </li>)}</ol>
                <small>The fraction shows completed stages. Some stages complete together in one transaction.</small>
            </div>
        </div>}
    </div>;
}
